import { AuthService } from './../../core/services/auth.service';
import { Injectable, OnDestroy } from '@angular/core';
// RxJS
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MenuService implements OnDestroy {
  // Public properties
  donarSubMenuShow$ = new BehaviorSubject(false);
  hideNav = false;
  hideOnlyRightNav$:BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  showCampaignSpecificLogos$:BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  menuList$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  destroy$ = new Subject();
  showWorkflow: boolean = false;
  menuClick$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  mastnacSubMenuEnable = false;
  locked = false;
  hideDynamicMenu$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(private authService: AuthService) {
  }

  set hideOnlyRightNav(val: boolean) {
      this.hideOnlyRightNav$.next(val);
  }

  loadMenu() {
    // const menuItems: any[] = objectPath.get(new MenuConfig().configs, 'aside');
    // const filteredMenuItems: any[] = this.accessControlService.applyMenuPermissions(menuItems);
    //this.menuList$.next(this.filterWorkflowMenu(filteredMenuItems));
  }

  showDonarSubMenu(value: boolean){
    this.donarSubMenuShow$.next(value);
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  hideDynamicMenu() {
    this.hideDynamicMenu$.next(true);
  }

  setMastnacAvailable(value: boolean) {
    this.mastnacSubMenuEnable = value;
  }

  setCustomerLocked(value: boolean) {
    this.locked = value;
  }

  onMenuClick(menuItem: string) {
    this.menuClick$.next(menuItem);
  }

  menuClicked = () => this.menuClick$.asObservable();
  donarSubMenuClick = () => this.donarSubMenuShow$.asObservable();
}
